<template>
  <div :class="cn('flex flex-col items-start rounded-t-xl bg-violet-50 p-5', props.class)">
    <div class="flex w-full flex-col justify-start">
      <span class="text-risk5 my-1.5 text-base font-medium">מה FINQ יכולה לעשות בשבילך</span>
    </div>

    <ul class="mt-2 flex w-full flex-col gap-3">
      <li class="flex items-center gap-3" v-for="(checklistItem, index) in items" :key="index">
        <Check class="text-risk5 aspect-square h-3.5 w-3.5 min-w-3.5" />
        <component :is="checklistItem" />
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { Check } from "lucide-vue-next"

const props = defineProps<{
  class?: ClassValue
  items: Component[]
}>()
</script>
